module.exports = "/_next/static/images/red-dress-bladder-pain@2x-min-6bd69ccea051256b5cb6f8b22a6f390a.png";